<template>
  <form-wrapper :title="option.title" :description="option.description" @submit="submit()" @previous="previous()"
    :isFirst="isFirst" :isLast="isLast" :disabled="isSaving">

    <b-form-group label="Monday" label-class="control-label" :class="{ 'invalid-group': $v.form.monday.$error }">
      <b-form-input v-model="form.monday" @input="handleInput"
        :class="{ 'is-invalid': $v.form.monday.$error }"></b-form-input>
      <span class="span-feedback invalid-feedback" v-if="$v.form.monday.$error">You must enter the hours as a
        number.</span>
    </b-form-group>

    <b-form-group label="Tuesday" label-class="control-label" :class="{ 'invalid-group': $v.form.tuesday.$error }">
      <b-form-input v-model="form.tuesday" @input="handleInput"
        :class="{ 'is-invalid': $v.form.tuesday.$error }"></b-form-input>
      <span class="span-feedback invalid-feedback" v-if="$v.form.tuesday.$error">You must enter the hours as a
        number.</span>
    </b-form-group>

    <b-form-group label="Wednesday" label-class="control-label" :class="{ 'invalid-group': $v.form.wednesday.$error }">
      <b-form-input v-model="form.wednesday" @input="handleInput"
        :class="{ 'is-invalid': $v.form.wednesday.$error }"></b-form-input>
      <span class="span-feedback invalid-feedback" v-if="$v.form.wednesday.$error">You must enter the hours as a
        number.</span>
    </b-form-group>

    <b-form-group label="Thursday" label-class="control-label" :class="{ 'invalid-group': $v.form.thursday.$error }">
      <b-form-input v-model="form.thursday" @input="handleInput"
        :class="{ 'is-invalid': $v.form.thursday.$error }"></b-form-input>
      <span class="span-feedback invalid-feedback" v-if="$v.form.thursday.$error">You must enter the hours as a
        number.</span>
    </b-form-group>

    <b-form-group label="Friday" label-class="control-label" :class="{ 'invalid-group': $v.form.friday.$error }">
      <b-form-input v-model="form.friday" @input="handleInput"
        :class="{ 'is-invalid': $v.form.friday.$error }"></b-form-input>
      <span class="span-feedback invalid-feedback" v-if="$v.form.friday.$error">You must enter the hours as a
        number.</span>
    </b-form-group>

    <b-form-group label="Saturday" label-class="control-label" :class="{ 'invalid-group': $v.form.saturday.$error }">
      <b-form-input v-model="form.saturday" @input="handleInput"
        :class="{ 'is-invalid': $v.form.saturday.$error }"></b-form-input>
      <span class="span-feedback invalid-feedback" v-if="$v.form.saturday.$error">You must enter the hours as a
        number.</span>
    </b-form-group>

    <b-form-group label="Sunday" label-class="control-label" :class="{ 'invalid-group': $v.form.sunday.$error }">
      <b-form-input v-model="form.sunday" @input="handleInput"
        :class="{ 'is-invalid': $v.form.sunday.$error }"></b-form-input>
      <span class="span-feedback invalid-feedback" v-if="$v.form.sunday.$error">You must enter the hours as a
        number.</span>
    </b-form-group>

  </form-wrapper>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { numeric } from "vuelidate/lib/validators";
import * as _ from "lodash";
import formWrapper from "./form-wrapper";
import opportunityApi from "../../../api/placements/opportunities";

export default {
  data() {
    return {
      form: {
        studentOpportunityHoursId: 0,
        monday: null,
        tuesday: null,
        wednesday: null,
        thursday: null,
        friday: null,
        saturday: null,
        sunday: null
      },
      supervisorOptions: [],
      isSaving: false
    };
  },

  props: {
    option: {
      type: Object,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    "form-wrapper": formWrapper
  },

  validations() {
    var validations = {
      form: {
        studentOpportunityId: 0,
        studentOpportunityHoursId: 0,
        monday: { numeric },
        tuesday: { numeric },
        wednesday: { numeric },
        thursday: { numeric },
        friday: { numeric },
        saturday: { numeric },
        sunday: { numeric }
      }
    };

    return validations;
  },

  computed: {
    ...mapState({
      userId: state => state.auth.user.userId,
      studentOpportunityId: state =>
        state.additionalMaterials.studentOpportunityId,
      studentOpportunity: state => state.additionalMaterials.studentOpportunity
    })
  },

  methods: {
    ...mapActions("placements", ["postStudentOpportunityContact"]),
    handleInput: function () {
      this.returnItem();
    },
    validate: function () {
      this.$v.$touch();
      this.returnItem();
    },
    returnItem: function () {
      this.$emit("input", this.form);
    },
    isInvalid: function () {
      return this.$v.$invalid;
    },
    previous: function () {
      this.$emit("previous");
    },
    submit: function () {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.isSaving = true;
        this.form.studentOpportunityHoursId = this.form
          .studentOpportunityHoursId
          ? this.form.studentOpportunityHoursId
          : 0;
        this.form.studentOpportunityId = this.studentOpportunity.studentOpportunityId;
        opportunityApi
          .postStudentOpportunityHours(this.form)
          .then(response => {
            if (response) {
              this.$emit("submitted");
            }
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    }
  },

  watch: {
    studentOpportunity: {
      handler: function () {
        if (this.studentOpportunity) {
          this.form = this.studentOpportunity.studentOpportunityHours;
        }
      },
      deep: true
    }
  },
  created() {
    if (this.studentOpportunity) {
      this.form = this.studentOpportunity.studentOpportunityHours;
    }
  }
};
</script>

<style>.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}</style>
